import React from 'react';
import { FormControl, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import { CONTROL_HEIGHT } from './controlSizing';

export interface ScheduleOption {
  value: string;
  label: string;
  disabled?: boolean;
}

interface ScheduleTypeSelectProps {
  value: string;
  options: ScheduleOption[];
  onChange: (e: SelectChangeEvent<string>) => void;
  disabled?: boolean;
}

/**
 * The "Schedule:" label + type dropdown. Every renderer drew this itself with
 * the same label, sizing and menu props, varying only in its option list.
 */
export const ScheduleTypeSelect: React.FC<ScheduleTypeSelectProps> = ({
  value,
  options,
  onChange,
  disabled,
}) => (
  <FormControl style={{ flexDirection: 'row', alignItems: 'center', marginTop: '13px' }}>
    <Typography component="label" color="text.primary">Schedule:</Typography>
    <Select
      disabled={disabled}
      sx={{ marginLeft: '10px', marginRight: '10px', height: CONTROL_HEIGHT }}
      MenuProps={{ disableScrollLock: true }}
      size="small"
      value={value}
      onChange={onChange}
      name="scheduledType"
    >
      {options.map((o) => (
        <MenuItem key={o.value} value={o.value} disabled={o.disabled}>
          {o.label}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);
